import { Box, Flex } from 'components/elements'
import { DetailContainer, DetailWrapper, DetailedCard, InfoColumn, MainWrapCSS } from 'features/incidents/components/style'
import { PlanReviewSummaryProps } from 'features/quote/components/type'
import { useEffect, useMemo } from 'react'
import { useForm } from 'react-hook-form'
import { serviceArrayAssessment, serviceLableAssessments } from 'configs/constants'
import { Form, userRegHeadingCss } from 'views/style'
import { BackNavArrowIcon } from 'components/icons'
import { Stages } from 'utils/enum'
import { BoxCss, Notification, textCss } from 'features/quote/components/GetAQuoteProcess/QuoteReview'
import { BorderCss } from 'features/quote/components/GetAQuoteProcess/PlanSelection'
import { QouteLayout } from 'features/quote/page/GetAQuotes'
import { ChangePolicyFormButtons } from './PolicyCoveragePlan'
import { TERMINOLOGY } from 'utils/enum'

const PolicyQuoteReview = (prop: PlanReviewSummaryProps) => {
  const { setOpenModal, setQuoteUserReg, setStage, quoteUserReg } = prop

  const quotedPremiumDiscount = quoteUserReg?.premiumInfo

  const services = useMemo(() => {
    return (prop?.quoteUserReg && prop.quoteUserReg.service) || []
  }, [prop?.quoteUserReg])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const { handleSubmit } = useForm()
  const onSubmit = () => {
    setStage?.(Stages.STAGE6)
  }
  const discountPercent = Number(quotedPremiumDiscount?.discountPercent)

  return (
    <>
      <Flex align="center">
        <BackNavArrowIcon fontSize={24} style={{ cursor: 'pointer' }} onClick={() => setStage?.(Stages.STAGE4)} />

        <Flex as="h2" justify={'center'} css={userRegHeadingCss}>
          Change {TERMINOLOGY.warranty.singular} Review
        </Flex>
      </Flex>
      <Flex align="start" justify="center" css={QouteLayout}>
        <Form onSubmit={handleSubmit(onSubmit)} css={{ width: '100%' }}>
          <Box css={{ textAlign: 'left' }}>
            <Box className="detail-box" style={{ padding: 0 }} css={{ ...MainWrapCSS, background: '$cardGradient', borderRadius: '8px' }}>
              <DetailedCard css={{ maxWidth: 'none', marginBottom: 0 }}>
                <Flex justify="start" direction="column">
                  <DetailWrapper css={{ border: 'none', p: 0 }}>
                    <Flex justify={'between'} wrap={'wrap'} css={{ mb: '$3', rowGap: '1rem' }}>
                      <Box as="h4" css={{ textAlign: 'start', m: 0 }}>
                        {TERMINOLOGY.warranty.singular} details
                      </Box>
                      {discountPercent > 0 && (
                        <Notification>
                          <Box as="span" css={{ textAlign: 'center' }}>
                            You saved {discountPercent}%
                          </Box>
                        </Notification>
                      )}
                    </Flex>
                    <DetailContainer css={BorderCss}>
                      <InfoColumn css={BoxCss}>
                        <Box as="p" className="t-title m-0 t-box">
                          {TERMINOLOGY.warranty.singular}
                        </Box>
                        <Box as="p" className={`t-value `} css={textCss}>
                          {quoteUserReg?.planName}
                        </Box>
                      </InfoColumn>
                      <InfoColumn css={BoxCss}>
                        <Box as="p" className="t-title m-0">
                          {TERMINOLOGY.benefit.singular}
                        </Box>
                        <Box as="p" className={`t-value `} css={textCss}>
                          ${quoteUserReg?.coverage}
                        </Box>
                      </InfoColumn>
                      <InfoColumn css={BoxCss}>
                        <Box as="p" className="t-title m-0">
                          Original Premium{' '}
                        </Box>
                        <Box as="p" className={`t-value `} css={textCss}>
                          ${quotedPremiumDiscount?.premium}
                        </Box>
                      </InfoColumn>
                      <InfoColumn css={BoxCss}>
                        <Box as="p" className="t-title m-0">
                          Discounted Premium
                        </Box>
                        <Box as="p" className={`t-value `} css={{ ...textCss, color: '$primary', fontSize: '$xl' }}>
                          ${quotedPremiumDiscount?.discountValue}
                        </Box>
                      </InfoColumn>
                    </DetailContainer>
                  </DetailWrapper>
                </Flex>
                <Flex justify={'start'} direction={'column'} css={{ mt: '$5' }}>
                  <Box as="h3" css={{ textAlign: 'start', fontSize: '1rem', fontWeight: '$normal', color: '$white', margin: 0 }}>
                    Monitoring services
                  </Box>
                  <Box css={{ textAlign: 'start' }}>
                    <Flex direction={'column'} wrap={'wrap'}>
                      {services?.map((item, idx) => {
                        const serviceName = serviceArrayAssessment[item - 1]
                        return (
                          <Flex direction={'row'} key={idx} wrap={'wrap'} css={{ width: '100%', padding: '.5rem' }}>
                            <Box as="span" css={{ fontWeight: '$normal', flexBasis: '40%', color: '$gray5' }}>
                              {serviceLableAssessments[serviceName]}
                            </Box>
                            <Box as="span" css={{ flexBasis: '50%' }}>
                              {serviceName}
                            </Box>
                          </Flex>
                        )
                      })}
                    </Flex>
                  </Box>
                </Flex>
              </DetailedCard>
            </Box>
          </Box>

          <ChangePolicyFormButtons setOpenModal={setOpenModal} setStage={setStage} setQuoteUserReg={setQuoteUserReg} />
        </Form>
      </Flex>
    </>
  )
}

export default PolicyQuoteReview
